import { Box, Link, Text } from '@opendoor/bricks-next';

export interface CityLink {
  name: string;
  slug: string;
  count: number;
  state: string;
}

interface CityLinkListProps {
  cities: CityLink[];
}

export const CityLinkList: React.FC<CityLinkListProps> = ({ cities }) => {
  if (!cities.length) {
    return null;
  }

  return (
    <Box tag="section" aria-label="Cities with homes for sale" py="$8x" flex={1}>
      <Box px="$4x" mx="auto">
        <Text tag="h2" typography="$headerSmall" mb="$6x">
          Cities with homes for sale
        </Text>
        <Box
          tag="ul"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
            gap: '1rem',
            listStyle: 'none',
            padding: 0,
            margin: 0,
          }}
        >
          {cities
            .filter((city) => city.count > 0)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((city) => (
              <Box tag="li" key={city.slug}>
                <Link
                  analyticsName="city-directory-link"
                  href={`/homes/${city.slug}`}
                  variant="primary"
                >
                  {city.name}, {city.state} ({city.count})
                </Link>
              </Box>
            ))}
        </Box>
      </Box>
    </Box>
  );
};
